__turbopack_context__.v({
  "className": "gotham_86a4bb45-module__KrBKsa__className",
  "variable": "gotham_86a4bb45-module__KrBKsa__variable",
});
